import { useCallback, useEffect, useRef, useState } from 'react'
import { CloudState } from './CloudSaveIndicator'

export const useCloudSaveState = () => {
  const [state, setState] = useState<CloudState>('idle')
  const savedTimerRef = useRef<ReturnType<typeof setTimeout>>(undefined)

  useEffect(
    () => () => {
      if (savedTimerRef.current) clearTimeout(savedTimerRef.current)
    },
    []
  )

  const onSaveStart = useCallback(() => {
    if (savedTimerRef.current) clearTimeout(savedTimerRef.current)
    setState('saving')
  }, [])

  const onSaveSuccess = useCallback(() => {
    setState('saved')
    savedTimerRef.current = setTimeout(() => {
      setState('synced')
    }, 5000)
  }, [])

  const onSaveError = useCallback(() => {
    if (savedTimerRef.current) clearTimeout(savedTimerRef.current)
    setState('error')
  }, [])

  return { cloudState: state, onSaveStart, onSaveSuccess, onSaveError }
}
